export default __webpack_public_path__ + "static/media/callus.a7646ea6.svg";